import { MatcherName, registerLocallyHandledErrorMatcher, singleErrorMatcher } from '../api/locallyHandledErrors';
import { toast } from '../components/common/Toast/Toast';
import i18n from '../i18n';
export const errorMatcher = singleErrorMatcher({ message: 'DataValidationException' });
export const dataValidationErrorHandler = () => (error) => {
    var _a, _b;
    if (errorMatcher(error)) {
        toast('error', i18n.t(`exceptions:${(_b = (_a = error.graphQLErrors) === null || _a === void 0 ? void 0 : _a[0].extensions) === null || _b === void 0 ? void 0 : _b.exceptionCode}`));
    }
    else {
        throw error;
    }
};
export const registerDataValidationErrorMatcher = () => registerLocallyHandledErrorMatcher(MatcherName.DataValidationException, errorMatcher);
